exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Table3 .table{display:table;border-collapse:collapse;width:100%}.Table3 .td,.Table3 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table3 a{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/Table3/Table3.scss
// module id = 1208
// module chunks = 30